<template>
  <div :class="$style.container">
    <template v-if="$mq.phone">
      <template v-if="toolbarData.userId">
        <div :class="$style.leftCol">
          <burger-menu v-if="settings.burgerMenu" />
        </div>
        <div
          v-if="isLocationSettings"
          :class="$style.centerCol"
        >
          <!-- <services :services="toolbarData.services" /> -->
          <dashboard-link :dashboard-url="toolbarData.portalUrl" />
        </div>
        <div
          :class="$style.rightCol"
        >
          <profile-dropdown
            :locales="toolbarData.locales"
            :profiles="toolbarData.profiles"
            :logout-url="toolbarData.logoutUrl"
            :settings-url="toolbarData.profileSettingsUrl"
            :add-profile-url="toolbarData.addProfileUrl"
            :user-email="toolbarData.userEmail"
          />
        </div>
      </template>
      <template v-else>
        <div :class="$style.leftCol">
          <burger-menu v-if="settings.burgerMenu" />
        </div>
        <div :class="$style.centerCol">
          <div :class="$style.logo">
            <logo :portal-url="toolbarData.portalUrl" />
          </div>
        </div>
        <div :class="$style.rightCol">
          <div :class="$style.separatorStyleSolid" />
          <div
            v-if="toolbarData.locales"
            :class="$style.language"
          >
            <language-dropdown :locales="toolbarData.locales" />
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <template v-if="toolbarData.userId">
        <div :class="$style.leftCol">
          <div :class="$style.logo">
            <logo :portal-url="toolbarData.portalUrl" />
          </div>
          <div :class="$style.separator" />
          <div
            v-if="isLocationSettings"
            :class="$style.services"
          >
            <dashboard-link :dashboard-url="toolbarData.portalUrl" />
          </div>
        </div>
        <div :class="$style.rightCol">
          <div
            :class="$style.profile"
          >
            <profile-dropdown
              :user-id="toolbarData.userId"
              :locales="toolbarData.locales"
              :profiles="toolbarData.profiles"
              :logout-url="toolbarData.logoutUrl"
              :settings-url="toolbarData.profileSettingsUrl"
              :user-email="toolbarData.userEmail"
            />
          </div>
          <div :class="$style.separatorStyleSolid" />
          <div
            :class="$style.logOut"
          >
            <settings-button
              :settings-url="toolbarData.settingsUrl"
              :locales="toolbarData.locales"
            />
          </div>
          <div :class="$style.separatorStyleSolid" />
          <div
            :class="$style.logOut"
          >
            <logout-button
              :logout-url="toolbarData.logoutUrl"
              :locales="toolbarData.locales"
            />
          </div>
          <div :class="$style.separatorStyleSolid" />
          <div
            v-if="toolbarData.locales"
            :class="$style.language"
          >
            <language-dropdown
              :profiles="toolbarData.profiles"
              :locales="toolbarData.locales"
            />
          </div>
        </div>
      </template>
      <template v-else>
        <div :class="$style.leftCol">
          <div :class="$style.logo">
            <logo :portal-url="toolbarData.portalUrl" />
          </div>
        </div>
        <div :class="$style.rightCol">
          <div :class="$style.login">
            <login-button
              v-if="toolbarData.loginUrl"
              :login-url="toolbarData.loginUrl"
              :login-state="settings.loginState"
              :login-redirect-url="settings.loginRedirectUrl"
            />
          </div>
          <div :class="$style.register">
            <register-button
              v-if="toolbarData.signUpUrl"
              :sign-up-url="toolbarData.signUpUrl"
            />
          </div>
          <div :class="$style.separatorStyleSolid" />
          <div
            v-if="toolbarData.locales"
            :class="$style.language"
          >
            <language-dropdown :locales="toolbarData.locales" />
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
  import LogoComponent from '@components/Logo'
  import BurgerMenuComponent from '@components/BurgerMenu'
  import LoginButtonComponent from '@components/LoginButton'
  import RegisterButtonComponent from '@components/RegisterButton'
  import ProfileDropdownComponent from '@components/ProfileDropdown'
  // import ServicesDropdownComponent from '@components/ServicesDropdown'
  import LanguageDropdownComponent from '@components/LanguageDropdown'
  import AccountLinkComponent from '@components/AccountLink'
  import LogOutButtonComponent from '@components/LogoutButton'
  import SettingsButtonComponents from '@components/SettingsButton'
  import DashboardLinkComponent from '@components/DashboardLink'

  export default {
    components: {
      logo: LogoComponent,
      // services: ServicesDropdownComponent,
      accountLink: AccountLinkComponent,
      burgerMenu: BurgerMenuComponent,
      loginButton: LoginButtonComponent,
      profileDropdown: ProfileDropdownComponent,
      registerButton: RegisterButtonComponent,
      languageDropdown: LanguageDropdownComponent,
      logoutButton: LogOutButtonComponent,
      settingsButton: SettingsButtonComponents,
      dashboardLink: DashboardLinkComponent
    },
    props: {
      toolbarData: {
        type: Object,
        default: _ => ({})
      },
      settings: {
        type: Object
      }
    },
    computed: {
      isLocationSettings () {
        return window.location.pathname.indexOf(this.trimEndingSlash(this.toolbarData.settingsPath)) === 0
      }
    },
    methods: {
      trimEndingSlash (s) {
        return (s != null && s.length > 0 && s[s.length - 1] === '/') ? s.slice(0, -1) : s
      }
    }
  }
</script>

<style lang="scss" module>
  @import "~@stylesheets/includes/vars";
  @import "~@stylesheets/includes/mixins";
  @import "~@stylesheets/common/fonts/OpenSans";
  @import "~@stylesheets/common/fonts/FuturaPT";

  /**
   * GLOBALS
   */
  .container {
    display: flex;
    align-items: stretch;
    color: #2d3e50;
    font-family: $font-default;
    font-size: 16px;
    background-color: #fff;
    box-shadow: 0px 1px 16px 0 rgba(26, 35, 46, 0.1);

    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: transparent;

    * {
      box-sizing: border-box;
    }

    a:focus {
      outline: none;
    }

    a {
      cursor: default;
    }

    a[href] {
      cursor: pointer;
    }

    img {
      border: none; // Remove IE 10 image borders
    }
  }

  /**
   * Left column
   */
  .leftCol {
    display: flex;
  }

  /**
   * Right column
   */
  .rightCol {
    display: flex;
  }

  /**
   * Center column
   */
  .centerCol {
    display: flex;
  }

  /**
   * Separator
   */
  .separator {
    display: flex;
    margin: auto 0px;
    width: 1px;
    height: 100%;
    background-image: linear-gradient(to top, rgba(235, 238, 242, 0) 0%, #ebeef2 52%, rgba(235, 238, 242, 0) 100%);
  }

  .separatorStyleSolid {
    composes: separator;
    background-image: none;
    background-color: #ebeef2;
  }

  /**
   * DESKTOP
   */
  @include desktop {
    /**
     * Toolbar
     */
    .container {
      height: 70px;
    }

    /**
     * Left column
     */
    .leftCol {
      align-items: stretch;
    }

    /**
     * Right column
     */
    .rightCol {
      align-items: stretch;
      margin-left: auto;
    }

    /**
     * Logo
     */
    .logo {
      display: flex;
      align-items: center;
    }

    /**
     * Services
     */
    .services {
      display: flex;
    }

    /**
     * Profile
     */
    .profile {
      display: flex;
    }

    /**
     * Profile
     */
    .logOut {
      display: flex;
    }

    /**
     * Language
     */
    .language {
      display: flex;
    }

    /**
     * Register
     */
    .register {
      display: flex;
      align-items: center;
      margin-right: 30px;
    }

    /**
     * Login
     */
    .login {
      display: flex;
    }
  }

  /**
   * PHONE
   */
  @include phone {
    /**
     * Toolbar
     */
    .container {
      height: 50px;
    }

    /**
     * Left column
     */
    .leftCol {
      width: 33%;
      justify-content: flex-start;
    }

    /**
     * Right column
     */
    .rightCol {
      width: 33%;
      justify-content: flex-end;
    }

    /**
     * Center column
     */
    .centerCol {
      width: 34%;
      justify-content: center;
    }

    /**
     * Services
     */
    .services {
      display: flex;
    }

    /**
     * Language
     */
    .language {
      display: flex;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Toolbar.vue